/* tslint:disable */

// AUTO-GENERATED FILE. DO NOT EDIT.

export const CURRENT_REVISION = "e6be0be3b6da41fe09fb1088a2bc1b88c7f156a8";
